import React from "react";
import Section from "../components/shared/Section";
import {
  Phone,
  Mail,
  MapPin,
  Instagram,
  Facebook,
  Twitter,
  Send,
} from "lucide-react";

export default function Contact() {
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // WhatsApp redirection logic
    const name = e.target.name.value;
    const email = e.target.email.value;
    const message = e.target.message.value;

    const whatsappMessage = `Hello, I’d like to request an appointment.\n\nName: ${name}\nEmail: ${email}\nMessage: ${message}`;
    const encodedMessage = encodeURIComponent(whatsappMessage);

    window.open(`https://wa.me/918878183433?text=${encodedMessage}`, "_blank");

    e.target.reset();
  };

  return (
    <Section id="contact">
      <div className="grid md:grid-cols-2 gap-10 items-start ">
        {/* Contact Info */}
        <div>
          <h3 className="text-3xl font-semibold tracking-tight text-yellow-200 text-center sm:text-left ">
           Contact Us
          </h3>
          {/* <p className="mt-3 text-neutral-300 text-center sm:text-left">
            Visit our flagship studio or schedule a virtual appointment with our design experts.
          </p> */}

          <div className="mt-6 flex flex-col sm:flex-row flex-wrap gap-3 text-sm text-yellow-100">
            <a
              href="tel:+919999999999"
              className="inline-flex items-center gap-2 rounded-full border border-yellow-400/40 px-4 py-2 hover:bg-yellow-400/10 transition"
            >
              <Phone className="h-4 w-4" /> +91-9880111242
            </a>
            <a
              href="mailto:concierge@beyondbox.example"
              className="inline-flex items-center gap-2 rounded-full border border-yellow-400/40 px-4 py-2 hover:bg-yellow-400/10 transition"
            >
              <Mail className="h-4 w-4" /> shreyans@beyondbox.co
            </a>
            <span className="inline-flex items-center gap-2 rounded-full border border-yellow-400/40 px-4 py-2">
              <MapPin className="h-4 w-4" /> 67, 3rd Floor, S Kariyappa Road, Basavanagudi, Bangaluru - 560004
            </span>
          </div>

          {/* <div className="mt-8 flex items-center gap-4 text-neutral-400">
            <a href="#" aria-label="Instagram" className="hover:text-yellow-200 transition">
              <Instagram className="h-5 w-5" />
            </a>
            <a href="#" aria-label="Facebook" className="hover:text-yellow-200 transition">
              <Facebook className="h-5 w-5" />
            </a>
            <a href="#" aria-label="Twitter" className="hover:text-yellow-200 transition">
              <Twitter className="h-5 w-5" />
            </a>
          </div> */}
        </div>

        {/* Contact Form */}
        <form className="space-y-5" onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <label className="block text-sm text-neutral-200">
              Name
              <input
                required
                name="name"
                className="mt-1 w-full rounded-xl border border-white/10 bg-black/30 px-4 py-3 placeholder:text-neutral-500 outline-none"
                placeholder="Your full name"
              />
            </label>
            <label className="block text-sm text-neutral-200">
              Email
              <input
                type="email"
                required
                name="email"
                className="mt-1 w-full rounded-xl border border-white/10 bg-black/30 px-4 py-3 placeholder:text-neutral-500 outline-none"
                placeholder="you@example.com"
              />
            </label>
          </div>
          <label className="block text-sm text-neutral-200">
            Message
            <textarea
              rows={4}
              required
              name="message"
              className="mt-1 w-full rounded-xl border border-white/10 bg-black/30 px-4 py-3 placeholder:text-neutral-500 outline-none"
              placeholder="Tell us what you’re looking for…"
            />
          </label>
          <button
            type="submit"
            className=" mt-2 inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold text-black bg-gradient-to-br from-yellow-300 to-amber-400 shadow-lg hover:brightness-110 transition"
          >
            Request Appointment <Send className="h-4 w-4" />
          </button>
        </form>
      </div>
    </Section>
  );
}
